import { CATALOG_SORT_OPTIONS } from 'features/catalog/consts'
import { SortType } from 'features/catalog/types'
import { useRouter } from 'next/router'

interface ICatalogSortedButtonProps {
  sort: SortType
}

const CatalogSortedButton = ({ sort }: ICatalogSortedButtonProps) => {
  const router = useRouter()
  const handleCategoryClick = (sort: string) => {
    void router.push({
      pathname: '/catalog',
      query: { ...router.query, sort },
    })
  }

  return (
    <div className="rounded-lg bg-gray-100 p-1">
      {CATALOG_SORT_OPTIONS.map(option => (
        <button
          key={option.value}
          onClick={() => handleCategoryClick(option.value)}
          className={`inline-flex items-center justify-center px-2 py-1.5 text-xs md:text-sm  ${
            sort === option.value ? 'rounded-md bg-white font-semibold' : 'text-gray-400'
          }`}>
          <span>{option.label}</span>
        </button>
      ))}
    </div>
  )
}

export default CatalogSortedButton
